const THOUSANDS = /^\d{1,3}(\.\d{3})+$/;
const AMOUNT = /^\d+(\.\d{0,2})?$/;

/** "12,5" · "12.50" · "1.234,56 €" → cents; empty → undefined; anything else → NaN. */
export function parseEuros(input: string): number | undefined {
  const text = input.replace(/[€\s]/g, '');
  if (text === '') return undefined;
  const normalised = text.includes(',')
    ? text.replace(/\./g, '').replace(',', '.')
    : THOUSANDS.test(text)
      ? text.replace(/\./g, '')
      : text;
  if (!AMOUNT.test(normalised)) return Number.NaN;
  return Math.round(Number(normalised) * 100);
}
